/* FENN: gaveta do menu (10/09/2026), versão 7 (11/09/2026).
 * A gaveta nativa do Horizon (snippets/header-drawer.liquid) é reposicionada pelo fenn-menu-gaveta.css pra começar
 * logo ABAIXO do cabeçalho real, que fica parado e visível (regra do Leonardo: o FENN do cabeçalho permanece sempre;
 * nunca copiar o cabeçalho pra dentro da gaveta). Este script:
 *  - mede onde o cabeçalho (#header-component) termina e grava --fenn-gaveta-topo no <header-drawer>, durante a
 *    rolagem (1x por quadro, só quando muda) e enquanto a gaveta está aberta;
 *  - monta o rodapé (Entrar, Rastrear meu pedido, Blog, Trocas, redes) dentro do bloco .menu-drawer__fenn-footer;
 *  - marca "em breve" no item Shorts;
 *  - bloqueia o arrasto do dedo fora da gaveta enquanto ela está aberta (a trava de rolagem do tema é relaxada no
 *    .page-wrapper pelo CSS, senão o cabeçalho sticky se desprende e some).
 * Tudo idempotente e religado por MutationObserver, porque o Horizon re-renderiza a gaveta depois do carregamento. */
(function () {
  function cab() { return document.getElementById('header-component'); }
  function gavetaEl() { return document.querySelector('header-drawer .menu-drawer'); }
  function details() { return document.getElementById('Details-menu-drawer-container'); }
  function aberta() { var d = details(); return !!(d && d.hasAttribute('open')); }

  function fechar() {
    var hd = document.querySelector('header-drawer');
    if (hd && typeof hd.close === 'function') { hd.close(); return; }
    var d = details(); if (d) d.removeAttribute('open');
  }

  // Leituras antes de escritas, e escrita só quando o valor muda (cada leitura depois de uma escrita força um layout da
  // página inteira; numa página pesada isso custa dezenas de ms e era parte da travada no toque).
  function medir() {
    var c = cab(); if (!c) return;
    var topo = Math.max(0, Math.round(c.getBoundingClientRect().bottom));
    var hds = document.querySelectorAll('header-drawer');
    for (var i = 0; i < hds.length; i++) {
      var st = hds[i].style;
      if (st.getPropertyValue('--fenn-gaveta-topo') !== topo + 'px') st.setProperty('--fenn-gaveta-topo', topo + 'px');
    }
  }

  function marcarEmBreve() {
    var itens = document.querySelectorAll('header-drawer .menu-drawer__menu-item--mainlist[href="/collections/shorts"] .menu-drawer__menu-item-text');
    for (var i = 0; i < itens.length; i++) {
      if (itens[i].querySelector('.fenn-em-breve')) continue;
      var s = document.createElement('small');
      s.className = 'fenn-em-breve';
      s.textContent = 'em breve';
      itens[i].appendChild(s);
    }
  }

  var RODAPE = '' +
    '<a href="/pages/rastrear-pedido" class="fenn-gaveta-rastrear"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 7.5 12 3l9 4.5v9L12 21l-9-4.5z"/><path d="M3 7.5 12 12l9-4.5M12 12v9"/></svg>Rastrear meu pedido</a>' +
    '<a href="/account" class="fenn-gaveta-conta"><svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="8" r="4"/><path d="M4 21c0-4 3.6-7 8-7s8 3 8 7"/></svg>' + (window.fennClienteLogado ? 'Minha conta' : 'Entrar') + '</a>' +
    '<a href="/blogs/blog" class="fenn-gaveta-blog"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 5.5A2.5 2.5 0 0 1 6.5 3H20v15H6.5A2.5 2.5 0 0 0 4 20.5z"/><path d="M4 20.5V5.5M8 7h8M8 10.5h8"/></svg>Blog</a>' +
    '<a href="/pages/faq" class="fenn-gaveta-menor">Trocas, devoluções e dúvidas</a>' +
    '<div class="menu-drawer__fenn-social" aria-label="Redes sociais da FENN">' +
      '<a href="https://www.instagram.com/fenn.br/" target="_blank" rel="noopener noreferrer" title="Instagram da FENN" aria-label="Instagram da FENN"><svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.3" cy="6.7" r=".9" fill="currentColor" stroke="none"/></svg></a>' +
      '<a href="https://www.tiktok.com/@fennbrasil" target="_blank" rel="noopener noreferrer" title="TikTok da FENN" aria-label="TikTok da FENN"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M14 3v11.5a3.5 3.5 0 1 1-3.5-3.5"/><path d="M14 3c.4 2.7 2.3 4.5 5 4.7"/></svg></a>' +
      '<span title="Facebook (em breve)"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M14 8h3V4h-3a4 4 0 0 0-4 4v3H7v4h3v6h4v-6h3l1-4h-4V8z"/></svg></span>' +
    '</div>';
  function montarRodape() {
    var blocos = document.querySelectorAll('header-drawer .menu-drawer__fenn-footer');
    for (var i = 0; i < blocos.length; i++) {
      if (blocos[i].dataset.fennPronto) continue;
      blocos[i].dataset.fennPronto = '1';
      blocos[i].classList.remove('menu-drawer__animated-element');
      blocos[i].innerHTML = RODAPE;
    }
  }

  function ligar() {
    marcarEmBreve();
    montarRodape();
    medir();
    var d = details();
    if (d && !d.dataset.fennGaveta) {
      d.dataset.fennGaveta = '1';
      new MutationObserver(function (muts) {
        var temOpen = d.hasAttribute('open');
        for (var k = 0; k < muts.length; k++) {
          if (muts[k].attributeName === 'open') {
            if (temOpen) { medir(); requestAnimationFrame(medir); }
            else d.classList.remove('fenn-fechando'); // fechamento concluído (o tema tirou o open)
          } else if (muts[k].attributeName === 'class') {
            // o tema tirou o menu-open por outro caminho (fundo, Esc, link): anima a saída também
            if (temOpen && !d.classList.contains('menu-open') && !d.classList.contains('fenn-fechando')) d.classList.add('fenn-fechando');
          }
        }
      }).observe(d, { attributes: true, attributeFilter: ['open', 'class'] });
    }
  }

  // Toque no sanduíche: mede antes de o tema abrir (a página pode estar deslizando). Se a gaveta JÁ está aberta, o
  // sanduíche é o X: impede o fechamento nativo do <details> (que fecharia na hora, sem deslizar, e ainda cancelava a
  // espera do tema pelo fim da animação, deixando uma promessa pendente que fechava a gaveta sozinha na abertura
  // seguinte). O tema (on:click="/toggle") continua recebendo o clique e faz o fechamento animado.
  document.addEventListener('click', function (e) {
    if (!(e.target && e.target.closest && e.target.closest('header-drawer summary'))) return;
    var d = details();
    if (aberta()) { e.preventDefault(); if (d) d.classList.add('fenn-fechando'); return; }
    if (d) d.classList.remove('fenn-fechando');
    medir(); requestAnimationFrame(medir);
  }, true);
  // Mede tambem durante a rolagem com a gaveta FECHADA (1x por quadro, so quando muda): assim, no toque, a posicao
  // ja esta certa e nada de geometria muda no mesmo instante em que o tema inicia a animaçao (o WebKit congelava
  // a transicao quando o top mudava junto com o transform; diagnosticado com Playwright em 11/09/2026).
  var agendado = false;
  function agendarMedida() { if (agendado) return; agendado = true; requestAnimationFrame(function () { agendado = false; medir(); }); }
  window.addEventListener('scroll', agendarMedida, { passive: true });
  var rol = document.querySelector('.page-wrapper'); if (rol) rol.addEventListener('scroll', agendarMedida, { passive: true }); // rolagem interna (fenn-rolagem.css)
  window.addEventListener('resize', agendarMedida);
  // iPhone: com a trava do tema relaxada no .page-wrapper, o dedo não pode arrastar a página por trás da gaveta
  document.addEventListener('touchmove', function (e) {
    if (!aberta()) return;
    var t = e.target;
    if (t && t.closest && t.closest('header-drawer .menu-drawer')) return;
    e.preventDefault();
  }, { passive: false });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ligar); else ligar();
  new MutationObserver(function () {
    var falta = !!document.querySelector('header-drawer .menu-drawer__fenn-footer:not([data-fenn-pronto])');
    var d = details();
    if (falta || (d && !d.dataset.fennGaveta)) ligar();
  }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', ligar);
})();
